import * as type from '../actions/types';

const initialState = {
  data: {},
  fetching: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_REVENUE_FORECAST_PENDING:
      return {
        ...state,
        fetching: true,
        errorMessage: false,
        success: false,
      };
    case type.FETCH_REVENUE_FORECAST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        fetching: false,
        error: false,
        errorMessage: '',
        success: true,
      };
    case type.FETCH_REVENUE_FORECAST_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        fetching: false,
      };

    default:
      return state;
  }
};
